<template>
	<MainView />
</template>

<script>
	import MainView from '../components/MainView'

	export default {
		// name: 'Homesaas',
			components: {
				MainView,
			},
	}
</script>